var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"flat":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","xs":"12"}},[_vm._v("Hier die Playliste die auch der client erhalten wird. ")]),_c('v-col',{attrs:{"cols":"12","xs":"12"}},[_c('pre',{staticClass:"preclass",staticStyle:{"font-size":"10px"},domProps:{"innerHTML":_vm._s(_vm.playlistsl)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }